import React from 'react';
import { MessageCircle, Phone } from 'lucide-react';

const PublicFloating = () => {
  const track = (label) => {
    if (window.gtag) window.gtag('event', 'click', { event_category: 'Floating contact', event_label: label });
  };
  return (
    <div className="floating-contact">
      <a href="tel:+971561868236" aria-label="Call Al Professor" onClick={() => track('Phone')}><Phone size={18} /></a>
      <a className="floating-whatsapp" href="https://wa.me/971561868236?text=Hello%2C%20I%20would%20like%20to%20book%20a%20vehicle%20inspection." target="_blank" rel="noopener noreferrer" aria-label="Chat with Al Professor on WhatsApp" onClick={() => track('WhatsApp')}>
        <MessageCircle size={20} /><span>WhatsApp</span>
      </a>
    </div>
  );
};

export default PublicFloating;
